import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
  type?: 'submit' | 'reset' | 'button' | undefined;
  leftIcon?: string;
  btnType?: 'primary' | 'secondary' | 'solid' | 'solid-primary';
  size?: 'sm' | 'md';
}

const Button = ({
  children,
  className = '',
  disabled = false,
  onClick = () => {},
  type = 'button',
  leftIcon,
  btnType = 'primary',
  size = 'md',
}: Props) => (
  <button
    onClick={onClick}
    type={type}
    disabled={disabled}
    className={`${className}  ${
      btnType === 'primary' && !disabled ? 'bg-[#007AC1] text-[#FFF]' : ''
    } ${
      btnType === 'secondary' && !disabled
        ? 'bg-[#FFF] text-primary border border-primary'
        : ''
    } ${
      size === 'sm' ? 'py-[10px] px-[20px]' : 'py-[14px] px-[32px]'
    }   rounded-xl flex items-center justify-center ${
      disabled && btnType === 'primary'
        ? 'cursor-not-allowed	bg-[#EEEEEE] text-disabledBorder'
        : ''
    } ${
      disabled && btnType === 'secondary'
        ? 'cursor-not-allowed border border-disabledBorder border-solid text-disabledBorder'
        : ''
    } `}
  >
    {leftIcon && (
      <span className="mr-3 md:mr-2">
        <img src={leftIcon} alt="leftIcon" />
      </span>
    )}
    {children}
  </button>
);

export default Button;
